module.exports = "/_next/static/images/heart@3x-9c6d1d3ed523064b48caa5d2a5d6fc61.png";